import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=287ad45c&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=287ad45c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287ad45c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287ad45c')) {
      api.createRecord('287ad45c', component.options)
    } else {
      api.reload('287ad45c', component.options)
    }
    module.hot.accept("./courseDetail.vue?vue&type=template&id=287ad45c&scoped=true", function () {
      api.rerender('287ad45c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/keeCourses/courseDetail.vue"
export default component.exports